export default {
    NAME: 'GST Admin Portal',
    VERSION: process.env.PACKAGE_VERSION,
    BUILD_TIMESTAMP: process.env.BUILD_TIMESTAMP ? process.env.BUILD_TIMESTAMP * 1 : null,
    PUBLIC_PATH: process.env.BASE_URL,
    OIDC_SETTINGS: {
        authority: '/auth/realms/gst-admin-realm',
        client_id: 'gst_admin_frontend',
        redirect_uri: window.location.origin + '/oidc-callback',
        scope: 'openid profile',
        post_logout_redirect_uri: window.location.origin,
        revokeAccessTokenOnSignout: true,
        monitorSession: false,
        silent_redirect_uri: `${window.location.origin}/silent-renew-oidc.html`,
        automaticSilentRenew: true,
        response_type: 'code',
    },
    ICONS: {},
};
